export default "__VITE_ASSET__B2zuM2si__"